(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-drawer"] && !Shopify.designMode) return;
  try {
    class DrawerModal extends HTMLElement {
  constructor() {
    super();
    this._boundKeyDown = this._onKeyDown.bind(this);
    // Bind ovde da delegation uvek radi
    this._boundClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this._boundClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._boundClick);
    document.removeEventListener('keydown', this._boundKeyDown);
  }

  _onClick(e) {
    // Zatvori ako je kliknut overlay ili close button
    if (e.target.closest('[data-drawer-close]')) {
      this.close();
    }
  }

  open(trigger) {
    this._trigger = trigger;
    this.removeAttribute('aria-hidden');
    this.classList.add('is-open');
    document.body.classList.add('drawer-open');
    document.addEventListener('keydown', this._boundKeyDown);

    const firstFocusable = this._getFocusable()[0];
    if (firstFocusable) firstFocusable.focus();

    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    document.removeEventListener('keydown', this._boundKeyDown);

    if (this._trigger) {
      this._trigger.setAttribute('aria-expanded', 'false');
      this._trigger.focus();
      this._trigger = null;
    }
  }

  _onKeyDown(e) {
    if (e.key === 'Escape') {
      this.close();
      return;
    }
    if (e.key === 'Tab') {
      this._trapFocus(e);
    }
  }

  _trapFocus(e) {
    const focusable = this._getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  _getFocusable() {
    return Array.from(
      this.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => !el.closest('[aria-hidden="true"]') && el.offsetParent !== null);
  }
}

customElements.define('drawer-modal', DrawerModal);
  } catch(e) { console.error(e); }
})();

})();
